export const matchPath = ({ location, matches }) => {
  const pathname = String(location.pathname);

  return matches.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`)
  );
};

export const isNavItemVisible = ({
  isLegacyPlatform,
  legacy,
  hasFeatureFlag,
  flag,
}) => {
  if (!isLegacyPlatform && legacy) return false;
  if (flag && !hasFeatureFlag(flag)) return false;
  return true;
};
